import React from 'react';
import { useTranslation } from 'react-i18next';
import IframePopup from '../IframePopup';
export var GroupListPopup = function (_a) {
    var title = _a.title, url = _a.url;
    var t = useTranslation().t;
    return (React.createElement(IframePopup, { title: t('sidebar.allGroups', { title: title }), initialWidth: 630, initialHeight: 343, src: url }));
};
export default GroupListPopup;
//# sourceMappingURL=GroupListPopup.js.map